import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AttendanceCycleSettings from './modal/attendance-cycle-settings';
// 考勤设置
import AttendanceSettings from './modal/attendance-settings';
// 考勤月度统计
import Statistics from './modal/statistics';
// api
// 获取月度考勤周期列表
import { getCycleList as _getCycleList } from 'api/Attendance/monthly-statistics';
import { yearList } from 'api/Attendance';
export default {
  components: {
    AttendanceCycleSettings: AttendanceCycleSettings,
    Statistics: Statistics,
    AttendanceSettings: AttendanceSettings
  },
  data: function data() {
    return {
      yearList: [],
      // 可选年份
      viewType: 1,
      // 1 主页面 2 考勤设置 3 列表页
      currentSelect: {},
      // 当前选中行
      settingForm: {
        tableLoading: false,
        year: '',
        // 搜索年份
        tableData: [] // 表格数据
      }
    };
  },
  mounted: function mounted() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;
      // 获取年份选项
      yearList().then(function (res) {
        var _res$data = res.data,
          years = _res$data.years,
          is_setting_cycle = _res$data.is_setting_cycle;
        _this.yearList = years;
        // 默认最后一年
        _this.settingForm.year = years.slice(-1)[0];
        // 考勤周期设置
        // 当企业未设置考勤周期时，每次进入月度汇总页面时弹出“考勤周期设置”弹窗。
        if (!is_setting_cycle) _this.$refs.attendanceSettings.visible = true;
        if (_this.settingForm.year) _this.getCycleList();
      });
    },
    // 更改展示
    handlerView: function handlerView(viewType) {
      this.viewType = viewType;
    },
    // 查看详情
    // row 表格当前行数据
    handleClick: function handleClick(row) {
      this.currentSelect = row;
      // 去往详情
      this.handlerView(3);
    },
    // 获取月度考勤周期列表
    getCycleList: function getCycleList() {
      var _this2 = this;
      this.settingForm.tableLoading = true;
      _getCycleList({
        year: this.settingForm.year
      }).then(function (res) {
        // 表格数据
        var date_range = res.data.date_range;
        _this2.settingForm.tableData = date_range;
      }).finally(function () {
        return _this2.settingForm.tableLoading = false;
      });
    }
  }
};